import { Component, Inject } from '@angular/core'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'

@Component({
  selector: 'app-integridade-resultado-modal',
  templateUrl: './integridade-resultado-modal.component.html',
  styleUrls: ['./integridade-resultado-modal.component.scss']
})
export class IntegridadeResultadoModalComponent {
  constructor(
    public dialogRef: MatDialogRef<IntegridadeResultadoModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  fechar(): void {
    this.dialogRef.close()
  }

  get reenviados(): any[] {
    return this.data.detalhes?.filter((d: any) => d.status === 'REENVIADO') || []
  }

  get falhas(): any[] {
    return this.data.detalhes?.filter((d: any) => d.status === 'FALHA') || []
  }
}
